import useTrackComponent from 'hooks/eventTracking/useTrackComponent'
import { Button, PlusIcon, styled } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { useMemo } from 'react'
import { useForm, useFormState } from 'react-final-form'
import { ActionType, EventType } from 'types/tracking'
import { FilterField, SuggestedFilter } from './types'

const AddFilterBtn = styled(Button)({
  marginTop: 10,
})

const ColumnWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

const StyledPlusIcon = styled(PlusIcon)({
  width: '12px !important',
  height: '12px !important',
})

interface SuggestedFilterSectionProps {
  suggestedFilters?: SuggestedFilter[]
  trackingComponentKey?: string
  trackingEventName?: string
}

const SuggestedFilterSection: React.FC<SuggestedFilterSectionProps> = ({
  suggestedFilters = [],
  trackingComponentKey = 'suggested_filter_section',
  trackingEventName = 'User Applied Filters',
}) => {
  const form = useForm()
  const translate = useTranslate()
  const formValues = useFormState().values
  const filtersList: FilterField[] = useMemo(() => formValues.filters || [], [formValues.filters])
  const { trackEvent } = useTrackComponent({
    componentKey: trackingComponentKey,
    eventName: trackingEventName,
  })

  const checkFilter = (fieldId: string) => !filtersList.some((filter) => filter.fieldId === fieldId)

  return (
    <ColumnWrapper>
      {suggestedFilters
        ?.filter((suggestedFilter) => checkFilter(suggestedFilter.id))
        .map((suggestedFilter) => (
          <div key={suggestedFilter.id}>
            <AddFilterBtn
              startIcon={<StyledPlusIcon />}
              variant={'contained'}
              color={'default'}
              onClick={() => {
                trackEvent(
                  EventType.USER_INTERACTION,
                  { type: ActionType.CLICK },
                  { selectedOption: suggestedFilter, filterSource: 'suggested' }
                )
                form.change('filters', [...filtersList, { fieldId: suggestedFilter.id, value: {} }])
              }}
            >
              {translate(suggestedFilter.name)}
            </AddFilterBtn>
          </div>
        ))}
    </ColumnWrapper>
  )
}

export default SuggestedFilterSection
